import { gndecLink } from "./links";

const educationData = [
  {
    id: 1,
    title: "Guru Nanak Dev Engineering College",
    timeline: "July 2015 - May 2019",
    link: gndecLink,
    subtitle: "B.Tech in Information Technology",
    description:
      "I studied Bachelor of Technology majoring in Information Technology at the GNDEC, Ludhiana.",
    data: [
      "At GNDEC, I worked hard to establish a good understanding of technical and process skills that are required to excel in the software field.",
      "Grand Finalist in Smart India Hackathon 2017 and were in top 10 teams out of 30 competing teams.",
      "Student Co-coordinator in College’s Placement Cell leading team of 50 placement executive conducting college placements of 25 companies and managing crowd of 400-500 students",
    ],
  },
];

export default educationData;
